const updateCreatorMemberships = (state, { payload: { memberships } }) => {
	state.creatorMemberships = memberships;
};

export default updateCreatorMemberships;
